export const inbox = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
<g>
   <g>
       <path d="M405.419,135.019c-5.333-8.533-15.456-17.685-27.957-17.685h-36.128c-5.891,0-10.667,4.776-10.667,10.667
           s4.776,10.667,10.667,10.667h36.128c2.901,0,7.147,3.285,9.824,7.573l100.181,163.093H354.357
           c-10.367,0-19.307,7.286-21.397,17.44l-5.771,28.875c-1.216,6.101-7.669,7.019-11.456,7.019H196.267
           c-2.325,0-10.005-0.544-11.424-7.691l-5.76-26.987c-2.133-10.667-11.307-18.656-21.333-18.656H24.533l100.192-163.04
           c2.709-4.341,6.944-7.627,9.856-7.627h36.085c5.891,0,10.667-4.776,10.667-10.667c0-5.891-4.776-10.667-10.667-10.667h-36.128
           c-12.501,0-22.635,9.131-27.989,17.739L0,308.459v159.808c0,18.225,14.746,33.014,32.971,33.067h446.059
           C497.254,501.28,512,486.492,512,468.267V308.459L405.419,135.019z M490.667,468.267c0,6.443-5.195,11.681-11.637,11.733H32.971
           c-6.443-0.053-11.638-5.29-11.637-11.733v-137.6l135.744-0.107c0.554,0.427,0.934,1.041,1.067,1.728l5.76,26.987
           C166.837,374.059,179.819,384,196.267,384h119.467c16.704,0,29.408-9.493,32.32-24.181l6.304-29.152h136.309V468.267z"/>
       <path d="M256,260.416l50.208-50.208c4.093-4.237,3.976-10.99-0.262-15.083c-4.134-3.993-10.687-3.993-14.821,0l-24.459,24.459
           V21.333c0-5.891-4.776-10.667-10.667-10.667c-5.891,0-10.667,4.776-10.667,10.667v198.251l-24.459-24.459
           c-4.237-4.093-10.99-3.975-15.083,0.262c-3.992,4.134-3.992,10.687,0,14.82L256,260.416z"/>
   </g>
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`;